module.exports = __webpack_public_path__ + "static/media/decisions_tree.1edc9dcf.ipynb";